import fetch from '../utils/fetch'

/*会员签到活动管理*/
export function getMembersSignActivitys (query) {
  return fetch({
    url: '/memberssigninactivity/getActivityList',
    method: 'get',
    params: query
  })
}


export function AddActivitys (query) {
  return fetch({
    url: '/memberssigninactivity/addActivity',
    method: 'post',
    params: query
  })
}

export function EditActivitys (query) {
  return fetch({
    url: '/memberssigninactivity/editActivity/'+query.id,
    method: 'put',
    params: query
  })
}

export function UpdateActivitys (query) {
  return fetch({
    url: '/memberssigninactivity/updateActivity',
    method: 'post',
    params: query
  })
}
export function signinList (query) {
  return fetch({
    url: '/memberssigninlog/getlist',
    method: 'get',
    params: query
  })
}
export function signinExport (query) {
  return fetch({
    url: '/memberssigninlog/signinexport',
    method: 'GET',
    params: query
  })
}
export function bsigninList (query) {
  return fetch({
    url: '/memberssigninredeemlog/getlist',
    method: 'get',
    params: query
  })
}
export function signinsList (query) {
  return fetch({
    url: '/memberssigninredeemnum/getlist',
    method: 'get',
    params: query
  })
}
export function signinaward (query) {
  return fetch({
    url: '/memberssigninaward/getlist',
    method: 'get',
    params: query
  })
}
export function signinawardExport (query) {
  return fetch({
    url: '/memberssigninaward/signinawardexport',
    method: 'GET',
    params: query
  })
}

// 重新发送签到奖励
export function resendSigninAward (query) {
  return fetch({
    url: '/memberssigninaward/resend',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/members_sign.js